import { useTranslation } from "react-i18next";
import { useGetQuestionnaireRequestsQuery } from "api/useQuestionnaireQueries";
import {
  QuestionnaireStatusResult,
  getQuestionnaireRequestsStatus,
} from "helpers/questionnaireStatus";
import { Typography } from "components/typography";
import PatientCardListItem from "./patientCardListItem";
import { Icon, Spacing } from "@mindlercare/ui-web";

type QuestionnairesPatientCardItemProps = {
  onClose: () => void;
  patientUserId: number;
};

const QuestionnairesPatientCardItem = ({
  onClose,
  patientUserId,
}: QuestionnairesPatientCardItemProps) => {
  const { t } = useTranslation();

  const { data: questionnaireRequests } = useGetQuestionnaireRequestsQuery(
    Number(patientUserId),
  );

  const renderStatus = (statusResult: QuestionnaireStatusResult) => {
    const getTextFromStatus = () => {
      if (statusResult.status === "NONE_SENT") {
        return t("NONE_SENT");
      }

      if (statusResult.status === "PENDING_RESPONSE") {
        if (statusResult.count === 1) {
          return t("1_PENDING_RESPONSE");
        }

        return t("N_PENDING_RESPONSES", { count: statusResult.count });
      }

      if (statusResult.status === "NEW_RESPONSE") {
        if (statusResult.count === 1) {
          return t("1_NEW_RESPONSE");
        }

        return t("N_NEW_RESPONSES", { count: statusResult.count });
      }

      return t("LAST_RESPONSE");
    };

    return (
      <Typography variant="body-small" style={{ whiteSpace: "nowrap" }}>
        <Typography variant="body-small" color={statusResult.color}>
          {getTextFromStatus()}
        </Typography>{" "}
        {"daysSince" in statusResult && (
          <Typography variant="body-small" color="GRAY">
            {statusResult.daysSince === 0
              ? t("TODAY")
              : t("DAYS_AGO", { days: statusResult.daysSince })}
          </Typography>
        )}
      </Typography>
    );
  };

  return (
    <>
      <Spacing t={8} />
      <PatientCardListItem
        onClose={onClose}
        to={`/questionnaires/${patientUserId}`}
        dataTestId={"cy-slot-questionnaires-link"}
        linkText={t("ACTION_CARD_QUESTIONNAIRE_TITLE")}
        icon={<Icon.CheckList width={20} />}
        footer={
          questionnaireRequests
            ? renderStatus(
                getQuestionnaireRequestsStatus(questionnaireRequests),
              )
            : undefined
        }
      />
    </>
  );
};

export default QuestionnairesPatientCardItem;
